export const BizAppConfig = {
  // 应用名称
  appName: process.env.UMI_APP_APP_NAME,

  // 多语言应用名称
  appNames: {
    'zh-CN': process.env.UMI_APP_APP_NAME_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_NAME_ZH_TW,
    'en-US': process.env.UMI_APP_APP_NAME_EN_US,
    'ja-JP': process.env.UMI_APP_APP_NAME_JA_JP,
  },

  // 应用 logo
  appLogo: process.env.UMI_APP_APP_LOGO,

  // 底部版权
  appFooterCopyright: process.env.UMI_APP_APP_FOOTER_COPYRIGHT,

  // 多语言底部版权
  appFooterCopyrights: {
    'zh-CN': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_TW,
    'en-US': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_EN_US,
    'ja-JP': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_JA_JP,
  },

  // API 地址（由不同环境配置文件注入 UMI_APP_API_URL）
  appApiUrl: process.env.UMI_APP_API_URL,

  // ============ 新建应用需要修改！！！ ============
  // SSO 客户端ID（优先读取环境变量，否则用默认值）
  appSsoClientId: process.env.UMI_APP_SSO_CLIENT_ID,

  // SSO 授权地址
  appSsoAuthorizeUrl: process.env.UMI_APP_SSO_AUTHORIZE_URL,

  // SSO 登出地址
  appSsoLogoutUrl: process.env.UMI_APP_SSO_LOGOUT_URL,

  // 个人中心地址
  appPersonalCenterUrl: process.env.UMI_APP_PERSONAL_CENTER_URL,

  // 企业管理地址
  // 支持占位符：{tenantUuid}、{organizationUuid}
  appTenantManagementUrl: process.env.UMI_APP_TENANT_MANAGEMENT_URL,

  // 开放平台地址
  appOpenPlatformUrl: process.env.UMI_APP_OPEN_PLATFORM_URL,

  // 元平台 Web 地址，用于跳转统一支付页面
  appMetaPlatformWebUrl: process.env.UMI_APP_META_PLATFORM_WEB_URL,

  // 工作台地址
  appWorkbenchUrl: process.env.UMI_APP_WORKBENCH_URL,
};
